<!-- 
  @desc 审批 --- qss，admin权限右边头部审批信息
  @version version=1.0.0 2019-11-05
  @author yd_yuliping
-->
<template>
  <el-dialog
    title="审批"
    :visible.sync="dialogVisible"
    width="50rem"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <el-form label-width="80px" size="small" :model="ApproveBaseVO">
      <el-row>
        <!-- <el-col :span="24">
          <el-form-item label="审批状态" required>
            <el-radio-group v-model="ApproveBaseVO.approveStatus">
              <template v-for="(item, index) in dict.approveStatus">
                <el-radio :label="item.code" :key="item.code" v-if="index > 1">
                  {{ item.name }}
                </el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
        </el-col> -->
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              rows="12"
              maxlength="100"
              show-word-limit
              resize
              v-model="ApproveBaseVO.approveRemark"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-row :gutter="30">
        <el-col :span="12" align="center">
          <el-button type="primary" @click="approveSubmit('VALID')" style="width: 60%;">
            审批通过
          </el-button>
        </el-col>
        <el-col :span="12" align="center">
          <el-button @click="approveSubmit('REJECTED')" style="width: 60%;">
            退回
          </el-button>
        </el-col>
      </el-row>
    </span>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";
import { ApproveBaseVO } from "@/libs/model";
export default {
  props: {
    approveInfo: Object
  },
  computed: {
    ...mapGetters(["dict"])
  },
  watch: {
    approveInfo() {
      this.ApproveBaseVO.approveStatus = this.approveInfo.approveStatus;
      this.ApproveBaseVO.approveRemark = this.approveInfo.approveRemark;
    }
  },
  data() {
    return {
      dialogVisible: false,
      ApproveBaseVO: new ApproveBaseVO()
    };
  },
  methods: {
    approveSubmit(approveStatus) {
      if (approveStatus === "REJECTED" && !this.ApproveBaseVO.approveRemark) {
        this.$message({ showClose: true, type: "error", message: "退回时请填写退回原因！" });
        return;
      }
      this.ApproveBaseVO.approveStatus = approveStatus;
      this.$emit("approveSubmit", this.ApproveBaseVO);
      this.dialogVisible = false;
      this.ApproveBaseVO = new ApproveBaseVO();
    },
    openDialog() {
      this.dialogVisible = true;
      this.ApproveBaseVO.approveStatus = this.approveInfo.approveStatus;
      this.ApproveBaseVO.approveRemark = this.approveInfo.approveRemark;
    },
    cancel() {
      this.dialogVisible = false;
      this.ApproveBaseVO = new ApproveBaseVO();
    }
  }
};
</script>
<style lang="scss" scoped></style>
